import { Box, TableRow, TableHead, TableContainer, TableCell, TableBody, Typography, Dialog, Rating, Button, TextField, Stack } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { StarBorder } from "@mui/icons-material";
import { Star } from "@mui/icons-material";
import { CompanyLogo } from "../../../company/components/CompanyLogo";
import { DoNotDisturb } from "@mui/icons-material";
import { DisplayBoxBase } from "../../../../components/shared/StyledComponents";
import { ReferralForm } from "../referral/ReferralForm";
import { useSchedulerByType } from "../../../../hooks";
import { IMeeting, SchedulerType } from "../../../../types";
import { CalendlyScheduler, MeetingDisplay } from "../../../meeting";
import { IAdvisor } from "../../../../types";
import { FeedbackForm } from "../feedback/FeedbackForm";

export const FollowUpPrompts = ({ advisor, containerStyle = "transparent" }: { advisor: IAdvisor, containerStyle?: "transparent" | "grey" | "white" }) => {

    const [showRefer, setShowRefer] = useState(false);
    const [showTrial, setShowTrial] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    const [meeting, setMeeting] = useState<IMeeting | null>(null);
    const [successPrompt, setSuccessPrompt] = useState<string | null>(null);

    const trialScheduler = useSchedulerByType({
        projectTag: advisor.survey_link.project.tag,
        type: SchedulerType.TRIAL,
        isPublic: true,
        enabled: !!(advisor && advisor.survey_link.project)
    });

    const handleActionSelect = (action: string) => {
        setSuccessPrompt(null);

        if (action === "refer") {
            setShowTrial(false);
            setShowFeedback(false);
            setShowRefer(true);
        } else if (action === "trial") {
            setShowRefer(false);
            setShowFeedback(false);
            setShowTrial(true);

        } else if (action === "feedback") {
            setShowRefer(false);
            setShowTrial(false);
            setShowFeedback(true);
        }
    }

    const handleReset = () => {
        setShowRefer(false);
        setShowTrial(false);
        setShowFeedback(false);
    }

    const handleTrialSuccess = (meeting: IMeeting) => {
        handleReset();
        setSuccessPrompt("trial")
        setMeeting(meeting);
    }

    const handleFeedbackSuccess = () => {
        handleReset();
        setSuccessPrompt("feedback")
    }

    const handleReferSuccess = () => {
        handleReset();
        setSuccessPrompt("refer")
    }

    return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Stack direction="row" gap={2} mb={2}>
            <DisplayBoxBase className={`column center ${showRefer ? "highlighted" : "transparent"}`} sx={{ gap: 2 }}>
                <Button variant="contained" color="primary" onClick={() => handleActionSelect("refer")}>
                    Refer a Colleague
                </Button>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>Earn shares when you refer a colleague as an advisor.</Typography>
            </DisplayBoxBase>
            <DisplayBoxBase className={`column center ${showTrial ? "highlighted" : "transparent"}`} sx={{ gap: 2 }}>
                <Button variant="contained" disabled={!trialScheduler.scheduler?.scheduling_url} color="primary" onClick={() => handleActionSelect("trial")}>
                    Explore a Rollout
                </Button>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>{advisor.survey_link.project.effective_scheduler_properties?.[SchedulerType.TRIAL]?.description}</Typography>
            </DisplayBoxBase>
            <DisplayBoxBase className={`column center ${showFeedback ? "highlighted" : "transparent"}`} sx={{ gap: 2 }}>
                <Button variant="contained" color="primary" onClick={() => handleActionSelect("feedback")}>
                    One Great Idea
                </Button>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>Share ideas that can transform the product.</Typography>
            </DisplayBoxBase>
        </Stack>
        {showRefer &&
            <DisplayBoxBase className={`${containerStyle} column`} sx={{ padding: containerStyle === "transparent" ? "0px" : "20px 30px", width: "100%" }}>
                <Typography variant="body1" mb={2} width="100%" fontWeight="bold">Please provide your colleague's name and email address.</Typography>
                <ReferralForm onSubmit={handleReferSuccess} onCancel={handleReset} size="small" />
            </DisplayBoxBase>
        }
        {showTrial && trialScheduler.scheduler &&
        <Box sx={{ width: "100%", marginTop: containerStyle === "transparent" ? "-60px" : "0px" }}>
            <DisplayBoxBase className={`${containerStyle} column`} sx={{ padding: containerStyle === "transparent" ? "0px" : "20px 30px", width: "100%" }}>
                <CalendlyScheduler inline={true} open={true} project={advisor.survey_link.project} scheduler={trialScheduler.scheduler} advisor={advisor} surveyLink={advisor.survey_link} setOpen={handleReset} onMeetingCreated={handleTrialSuccess} />
            </DisplayBoxBase>
        </Box>
        }
        {showFeedback &&
            <DisplayBoxBase className={`${containerStyle} column`} sx={{ padding: containerStyle === "transparent" ? "0px" : "20px 30px", width: "100%" }}>
                <FeedbackForm advisor={advisor} onCancel={handleReset} onSubmit={handleFeedbackSuccess} />
            </DisplayBoxBase>
        }
        {successPrompt === "refer" &&
            <DisplayBoxBase className={`${containerStyle} column center`} sx={{ padding: containerStyle === "transparent" ? "0px" : "20px 30px"}}>
                <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "center" }}>Thank your referral.</Typography>
            </DisplayBoxBase>
        }
        {successPrompt === "trial" &&
            <DisplayBoxBase className={`${containerStyle} column center`} sx={{ padding: containerStyle === "transparent" ? "0px" : "20px 30px"}}>
                <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "center" }}>You're set for your {meeting?.scheduler?.type} meeting with {advisor.survey_link.project.name}!</Typography>
                <MeetingDisplay meeting={meeting} advisor={advisor} size="small" />
            </DisplayBoxBase>
        }
        {successPrompt === "feedback" &&
            <DisplayBoxBase className={`${containerStyle} column center`} sx={{ padding: containerStyle === "transparent" ? "0px" : "20px 30px"}}>
                <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "center" }}>Thank you for your feedback.</Typography>
            </DisplayBoxBase>
        }
    </Box>)
};
